import createInvoiceFieldMutation from './createInvoiceFieldMutation'

const useMarkAsUnpaid = createInvoiceFieldMutation({ paid: false }, 'markAsUnpaid')

export default useMarkAsUnpaid
